<template>
  <section class="mt-10">
    <div class="w-full">
      <div class="flex lg:flex-row flex-col justify-between items-center">
        <div
          class="grid grid-cols-12 gap-x-2 background py-1.5 px-2 rounded-lg mb-5 lg:mb-0"
        >
          <div
            class="col-span-4 flex justify-center text-13px py-2.5 px-2 cursor-pointer transition-all duration-150 ease-linear"
            @click="setActiveClass($transactionType.DEPOSIT)"
            :class="
              isDepositTransaction
                ? 'bg-white rounded-md text-primary font-bold shadow-md'
                : 'font-normal'
            "
          >
            Deposits
          </div>
          <div
            class="col-span-4 flex justify-center text-13px py-2.5 px-2 cursor-pointer"
            @click="setActiveClass($transactionType.WITHDRAWAL)"
            :class="
              isWithdrawalTransaction
                ? 'bg-white rounded-md text-primary font-bold shadow-md'
                : 'font-normal'
            "
          >
            Withdrawals
          </div>
          <div
            class="col-span-4 flex justify-center text-13px py-2.5 px-2 cursor-not-allowed"
            :class="
              isPaymentLinkTransaction
                ? 'bg-white rounded-md text-primary font-bold shadow-md'
                : 'font-normal'
            "
          >
            Payment Link
          </div>
        </div>
        <div class="flex items-center gap-x-3">
          <div
            class="border border-root-3 rounded-lg flex items-center gap-x-2 px-3 py-2"
          >
            <currency-icons :currency="getCurrencyCountry(selectedCurrency)" />
            <p class="text-13px text-root-2 font-medium">
              {{ selectedCurrency }}
            </p>
          </div>
          <div
            class="flex items-center gap-x-1 border border-root-3 text-root-2 px-2.5 py-2 rounded-md cursor-pointer"
            @click="showDialog('showTableFilter')"
          >
            <filter-icon />
            <p class="text-black-2 text-13px px-2 font-medium">Filter</p>
            <arrow-down-icon />
          </div>
        </div>
      </div>
      <!-- Tables -->
      <div class="mt-5">
        <transaction-table
          v-if="isDepositTransaction"
          :tableData="transactionTableData"
          @handleCurrentChange="handleCurrentChange"
          :isLoading="tableLoading"
          :page="page"
          :transactionType="activeClass"
        />
        <transaction-table
          v-if="isWithdrawalTransaction"
          :tableData="transactionTableData"
          @handleCurrentChange="handleCurrentChange"
          :isLoading="tableLoading"
          :page="page"
          :transactionType="activeClass"
        />
      </div>
    </div>
    <filter-dialog
      :showDialog="showTableFilter"
      @filterParams="searchFilterParams"
      @closeDialog="closeDialog('showTableFilter')"
      @cancel="closeDialog('showTableFilter')"
    />
  </section>
</template>

<script>
import { GetCurrencyCountry, GetNetworkFullName } from '@/utils/helpers.js'
import applyDateFilter from '@/mixins/app.js'
export default {
  data () {
    return {
      mixins: [applyDateFilter],
      activeClass: 'deposit',
      refreshToolTipContent: 'Reset filter settings to default',
      showTableFilter: false,
      isLoading: true,
      payload: {
        page: 1,
        size: 10,
        status: '',
        from: '',
        to: '',
        type: 'deposit',
        sort_by: 'created_at',
        sort_direction_desc: true,
        currency: ''
      }
    }
  },
  props: {
    pageLoading: {
      type: Boolean
    }
  },
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    ArrowDownIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue'),
    FilterDialog: () =>
      import('@/components/v2/transactions/dialogs/FilterDialog.vue'),
    FilterIcon: () => import('@/assets/v2/icons/FilterIcon.vue'),
    TransactionTable: () =>
      import('@/components/v2/transactions/tables/TransactionTable.vue')
  },
  methods: {
    handleCurrentChange (payload) {
      this.payload.page = payload.val
      this.getTransactions()
    },
    getTransactions () {
      this.payload.currency = this.selectedCurrency
      this.isLoading = true
      this.$store
        .dispatch('transactions/getTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
    },
    showDialog (dialog) {
      this[dialog] = true
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    getNetworkFullName (val) {
      return GetNetworkFullName(val)
    },
    setActiveClass (arg) {
      this.activeClass = arg
      this.payload.type = arg
      this.getTransactions()
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    searchFilterParams (filterParams) {
      this.applyDateFilter(filterParams)
      this.getTransactions()
    }
  },
  async mounted () {
    await this.getTransactions()
  },
  computed: {
    tableLoading () {
      return this.pageLoading || this.isLoading
    },
    transactionTableData () {
      return this.$store.state.transactions?.transactions?.items || []
    },
    page () {
      return this.$store.state.transactions?.transactions?.page || {}
    },
    selectedCurrency () {
      return this.$store.state.report.accountDetailsCurrency
    },
    isDepositTransaction () {
      return this.activeClass === this.$transactionType.DEPOSIT
    },
    isWithdrawalTransaction () {
      return this.activeClass === this.$transactionType.WITHDRAWAL
    },
    isPaymentLinkTransaction () {
      return this.activeClass === this.$transactionType.PAYMENT_LINK
    }
  }
}
</script>

<style scoped>
.background {
  background: var(--background-muted);
}
</style>
